class AyumeMediaGallery extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const {signal} = this.abort;
    const track = this.querySelector('.ayume-gallery-track');
    const slides = [...track.children];
    const buttons = [...this.querySelectorAll('[data-media]')];
    const previous = this.querySelector('[data-gallery-prev]');
    const next = this.querySelector('[data-gallery-next]');
    let current = 0, frame;
    const select = index => {
      const slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
      const smooth = !matchMedia('(prefers-reduced-motion:reduce)').matches && document.documentElement.dataset.avMotion !== 'off';
      track.scrollTo({left:slide.offsetLeft - slides[0].offsetLeft, behavior:smooth ? 'smooth' : 'instant'});
    };
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        if (index !== current) slides[current]?.querySelector('video')?.pause();
        current = index;
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
        const position = this.querySelector('[data-gallery-position]');
        if (position) position.textContent = String(current + 1);
        if (previous) previous.disabled = current === 0;
        if (next) next.disabled = current === slides.length - 1;
      });
    };
    buttons.forEach((button, i) => button.addEventListener('click', () => select(i), {signal}));
    previous?.addEventListener('click', () => select(current - 1), {signal});
    next?.addEventListener('click', () => select(current + 1), {signal});
    track.addEventListener('scroll', update, {passive:true, signal});
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      select(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
    }, {signal});
    // Native horizontal scrolling handles both finger swipes and trackpad inertia.
    this.resize = new ResizeObserver(() => {
      track.scrollTo({left:current * track.clientWidth, behavior:'instant'});
      update();
    });
    this.resize.observe(track);
  }
  disconnectedCallback() { this.abort?.abort(); this.abort = null; this.resize?.disconnect(); }
}
if (!customElements.get('ayume-media-gallery')) customElements.define('ayume-media-gallery', AyumeMediaGallery);
